import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    {...props}
    width="35"
    height="40"
    viewBox="0 0 35 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.66272 3.00012L3.1062 3.55664L5.71722 6.16766L6.27374 5.61114L3.66272 3.00012Z"
      fill="#848B99"
    />
    <path
      d="M0.442144 10.2565L0.202881 11.0063L3.67081 12.1129L3.91007 11.3631L0.442144 10.2565Z"
      fill="#848B99"
    />
    <path
      d="M4.4833 23.2356L1.41846 25.2949L1.85739 25.9482L4.92223 23.8888L4.4833 23.2356Z"
      fill="#848B99"
    />
    <path
      d="M3.61608 17.009L0 17.4272L0.0904321 18.2091L3.70651 17.7909L3.61608 17.009Z"
      fill="#848B99"
    />
    <path
      d="M29.4879 22.873L27.1136 32.1143C26.9168 32.9604 26.0773 33.4851 25.2312 33.2883C25.2247 33.2883 25.2181 33.2883 25.2116 33.2818L23.7424 32.9079C22.8963 32.6784 22.3913 31.8192 22.6012 30.9665L24.4376 23.483L29.4879 22.873Z"
      fill="#11A8E4"
    />
    <path
      d="M33.9873 19.1739L33.6922 21.2333C33.5151 22.4467 32.387 23.2928 31.1671 23.1157L29.488 22.873L30.5899 16.4258L32.105 16.6488C33.3183 16.8259 34.1644 17.954 33.9873 19.1739Z"
      fill="#11A8E4"
    />
    <path
      d="M20.9681 28.6839L23.0342 29.2021L24.1688 24.6831L20.7124 27.405C20.2401 27.7788 20.391 28.5397 20.9681 28.6839Z"
      fill="#FE664C"
    />
    <path
      d="M30.59 16.4258L29.4881 22.873L24.4444 23.483L22.4243 23.7978C23.1458 22.0335 23.6508 20.1839 23.9263 18.295C24.1755 16.616 24.2345 14.9173 24.1099 13.2251L30.59 16.4258Z"
      fill="#64D2FF"
    />
    <path
      d="M18.2724 17.3312C17.8264 20.3941 16.823 23.0701 15.5833 24.8606C14.4552 26.4937 13.1238 27.3989 11.8383 27.2086C10.8938 27.0709 10.1002 26.3691 9.49683 25.2607C9.84444 25.6608 10.2511 25.91 10.6971 25.969C11.4448 26.074 12.2121 25.6608 12.9336 24.8541C13.4977 24.2244 14.0355 23.3587 14.5143 22.3093C14.9931 21.2664 15.3997 20.0399 15.7145 18.6954C15.7342 18.597 16.0621 16.8721 16.0621 16.8721C16.1408 16.3408 16.2917 14.6814 16.3048 14.3797C16.4032 12.0251 16.1212 9.96569 15.5243 8.549C15.0586 7.44713 14.4028 6.7519 13.6092 6.64041C13.2747 6.59449 12.9336 6.65352 12.5991 6.80437C13.3534 6.19441 14.147 5.91238 14.9275 6.02388C16.3376 6.23376 17.4198 7.70948 18.0101 9.9001C18.5545 11.9136 18.6856 14.5306 18.2724 17.3312Z"
      fill="#26B2D1"
    />
    <path
      d="M16.3048 14.3795C16.2917 14.6812 16.1409 16.3406 16.0622 16.8719C16.0622 16.8719 15.7342 18.5968 15.7145 18.6952C15.3997 20.0397 14.9931 21.2662 14.5143 22.3091C14.0421 23.3585 13.4977 24.2242 12.9336 24.8539C12.2056 25.6606 11.4448 26.0738 10.6971 25.9688C10.2511 25.9033 9.84447 25.6606 9.49685 25.2605C8.92624 24.6112 8.49992 23.5487 8.25069 22.2172C8.25069 22.2172 7.68664 19.4232 8.25069 15.7569C8.87377 11.5921 10.4741 8.19463 12.1663 7.04685C12.3106 6.94847 12.4548 6.86976 12.5991 6.80417C12.9402 6.65332 13.2813 6.59429 13.6092 6.6402C14.4028 6.7517 15.0521 7.44693 15.5243 8.5488C16.1212 9.96549 16.4032 12.0249 16.3048 14.3795Z"
      fill="#3A6CA7"
    />
    <path
      d="M16.2457 15.3045C16.2064 15.8161 16.1473 16.3408 16.0686 16.8721C16.0686 16.8721 15.885 17.9871 15.7997 18.3937C15.7801 18.4921 15.7538 18.597 15.7341 18.6954C14.4224 18.597 13.0254 18.4396 12.8745 18.4134C11.7267 18.2494 10.92 17.2787 11.0709 16.249C11.2217 15.2193 12.2711 14.524 13.4189 14.688C13.5698 14.7274 14.9864 14.9897 16.2457 15.3045Z"
      fill="#FFC061"
    />
    <path
      d="M23.9197 18.2951C23.6442 20.184 23.1392 22.027 22.4177 23.7913L15.5835 24.8604C16.8231 23.0699 17.8266 20.3939 18.2726 17.331C18.6858 14.5304 18.5546 11.9134 18.0102 9.8999L24.1033 13.2252C24.2279 14.9173 24.1689 16.6161 23.9197 18.2951Z"
      fill="#C2C5C6"
    />
  </SvgIcon>
));
